var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2048 4.5C9.33494 4.5 7 6.83476 7 9.70483C7 11.6144 8.06031 13.3757 9.72892 14.286V15.3615C9.72892 15.6609 9.97165 15.9037 10.2711 15.9037H14.1207C14.4201 15.9037 14.6628 15.661 14.6628 15.3615V14.2875C16.3425 13.3808 17.4097 11.6187 17.4097 9.70486C17.4097 6.83476 15.0747 4.5 12.2048 4.5ZM13.8959 13.4584C13.7025 13.5465 13.5783 13.7393 13.5783 13.9518V14.8193H10.8133V13.9518C10.8133 13.7402 10.69 13.5477 10.4979 13.4594C9.03171 12.784 8.08434 11.3102 8.08434 9.70483C8.08434 7.43277 9.93277 5.58434 12.2048 5.58434C14.4769 5.58434 16.3253 7.43277 16.3253 9.70483C16.3253 11.3127 15.3717 12.7862 13.8959 13.4584Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7048 16.6266H10.7048C10.4053 16.6266 10.1626 16.8693 10.1626 17.1688C10.1626 17.4682 10.4053 17.7109 10.7048 17.7109H13.7048C14.0042 17.7109 14.2469 17.4682 14.2469 17.1688C14.2469 16.8693 14.0042 16.6266 13.7048 16.6266Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8374 18.4156H11.5723C11.2729 18.4156 11.0302 18.6584 11.0302 18.9578C11.0302 19.2573 11.2729 19.5 11.5723 19.5H12.8374C13.1368 19.5 13.3796 19.2573 13.3796 18.9578C13.3795 18.6584 13.1368 18.4156 12.8374 18.4156Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBulb);
export default __webpack_public_path__ + "static/media/icon-bulb.0116a69bdceed302f259dbc9ac98684e.svg";
export { ForwardRef as ReactComponent };